export default {
  // logo: "雨欣基因",
  logo: "乐辰生物",

  common: {
    welcome: "欢迎",
    about: "关于我们",
    contact: "联系我们",
    instrument: "仪器",
    home: '主页',
    product: '产品',
    solution: '解决方案',
    newsCenter: '新闻中心',
    Documents: '文件',
    Certificattion: '企业认证',
    ApplicationNotes: '产品应用',
    Publications: '文献发表',
    SafetyDataSheets: '产品安全说明',
    aboutUs: '关于我们',
    joinUs: '加入我们',
    contactUs: '联系我们',
    recruitment: '人才招聘',
    companyNews: '公司新闻',
    industryNews: '行业动态',
    name: '姓名',
    collaboration: '科研合作',
    achievements: '科研成果',
  },

  homePage: {
    ourServices: '我们的服务',
    newsCenter: '新闻中心',
    viewMore: '查看更多',
    viewDetails: '查看详情'
  },

  InstrumentPage: {
    useCases: '使用实例',
    relatedVideos: '视频介绍',
    downloadMaterials: '资料下载',
    preview: '预览',
    download: '下载',
    previewPDFOnly: '只能预览PDF!',
  },

  AboutUs: {
  companyProfile: '关于乐辰',
    companyVision: '使命愿景',
    about1: '关于乐辰',
    about2: '使命愿景',
    about3: '荣誉资质',
    about4: '科研合作',
    about5: '科研成果',
    about6: '用户代表',
  },

  Footer: {
    companyAddress: '公司地址',
    phone: '电话',
    num1: '021-56670577',
    num2: '400-0021-908',
    email: '邮箱',
    allRightsReserved: '版权所有',
    fullAddress: '上海市宝山区富联三路99号三幢',
    name: '上海乐辰生物科技有限公司',
    // name: '上海雨欣基因科技有限公司',
    instrument: "仪器",
    reagent: '试剂',
    software: '软件',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    recruitment: '人才招聘',
    logoName: '乐辰生物',
    ProductOrdering: '产品订购',
    CorporateWeChatAccount: '企业公众号',
  },

  productList: {
    instrument: "仪器",
    reagent: '试剂',
    software: '软件'
  },

  Recruitment: {
    recruitment: '人才招聘',
    viewRequirements: '查看职位要求'
  },

  RecruitmentDetails: {
    jobResponsibilities: '工作职责',
    qualifications: '任职资格',
    salaryAndBenefits: '薪资待遇',
    resumeSubmissionPDF: '简历投递（PDF）',
    submitted: '已投递',
    pdfOnly: '只能上传PDF!',
    fileSizeLimit: '上传文件大小不能超过 10MB!'
  },

  NewsCenter: {
    newsCenter: '新闻中心',
    enterKeyword: '请输入关键字',
  },

  ContactUs: {
    position: '职位',
    company: '单位',
    Unit: '单位',
    email: '邮箱',
    phone: '电话',
    vx: '微信',
    message: '留言',
    submit: '提交',
    cancel: '取消',
    reset: '重置',
    required: '必填',
    minLength3: '不能少于3个字',
    enterEmail: '请输入邮箱',
    invalidEmail: '邮箱格式错误',
    enterPhone: '请输入手机号码',
    invalidPhone: '手机号格式错误',
    cannotEmpty: '不能为空',
    submitted: '已提交',
    submitFailed: '提交失败',
    allComments: '全部留言',
    password: '输入密码',
    wrongPassword: '密码错误',
    passwordCorrect: '密码正确',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh-CN.js